/*
 * File: main.ts
 * Created: 2025-12-03 08:55:10
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2025-12-05 11:36:47
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

import { Component } from "vue-property-decorator";
import { ThemeBase } from "@root/components/theme/theme-base/theme-base"; // 路徑依你實際位置調整
import QuaffBlueContainer from "./components/QuaffBlueContainer.vue"; // 你的藍色版佈局元件

@Component({
    components: {
        // 🔑 關鍵：沿用 ThemeBase / main.vue 裡使用的同一個 key：DefaultContainer
        // 這樣 main.vue 裡 <DefaultContainer> 實際 render 的就是 QuaffBlueContainer
        Container: QuaffBlueContainer,
    },
})
export class QuaffBlueTheme extends ThemeBase {
    themeName: string = "v-theme-quaff";
}
export default QuaffBlueTheme;
